import apiFetch from '../apiFetch'

export default function (token, values) {
  return apiFetch({endPoint: `Combos/getComboRutasTransportistaCliente`, method: 'POST', body: values, token: token})
}